import { useAppStore } from '../../store/app'
import { NavBar, NavBarButton } from '../../components/NavBar'
import { ResourcesSegment } from './segments/ResourcesSegment'
import './AgentResourcesScreen.css'

export function AgentResourcesScreen({ agentInstanceID }: { agentInstanceID: string }) {
  const popNav = useAppStore((s) => s.popNav)
  return (
    <div className="agent-resources-screen">
      <NavBar
        title="Resources & Skills"
        leading={<NavBarButton icon="‹" label="Back" onClick={popNav} />}
      />
      <ResourcesSegment agentInstanceID={agentInstanceID} />
    </div>
  )
}
